import axios from '@/config/httpConfig'

// 队列
export function queryQueue(data) {
  return axios.post('/objectdetail/queryQueue', data)
}
